export default "__VITE_ASSET__259fee97__"